import { createI18n, type DefaultLocaleMessageSchema } from 'vue-i18n';
import enus from './en-us';
import esus from './es-us';
import enca from './en-ca';
import frca from './fr-ca';
import { enCA, enUS, esUS, frCA } from '@primerica/onex-ui-lib';

const usNumberFormat = {
  currency: {
    style: 'currency',
    currency: 'USD',
  },
  currencyNoCents: {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
};

const caNumberFormat = {
  currency: {
    style: 'currency',
    currency: 'CAD',
  },
  currencyNoCents: {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
};

const numberFormats = {
  'en-US': usNumberFormat,
  'es-US': usNumberFormat,
  'en-CA': caNumberFormat,
  'fr-CA': caNumberFormat,
};

const options = {
  messages: {
    'en-US': { ...enUS, ...enus },
    'es-US': { ...esUS, ...esus },
    'en-CA': { ...enCA, ...enca },
    'fr-CA': { ...frCA, ...frca },
  },
  locale: 'en-US',
  fallbackLocale: 'en-US',
  numberFormats,
  legacy: true,
  allowComposition: true,
};
export default createI18n<[DefaultLocaleMessageSchema], 'en-US' | 'es-US', true>(options);
